<template>
    <div class="overflow-auto">
        <table class="vocabulary table table-bordered">
            <tbody>
                <tr
                    v-for="(wordRow, i) in wordRows"
                    :key="i"
                >
                    <td
                        v-for="(word, j) in wordRow"
                        :key="j"
                        :class="colWidthClass"
                    >
                        <component
                            :is="word"
                            :reversed="reversed"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Word from './Word.vue'

export default {
    name: 'Vocabulary',
    components: {
        Word,
    },
    props: {
        cols: {
            type: Number,
            default: 2
        },
        reversed: {
            type: Boolean,
            default: false
        },
        colDiffWidth: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // Get the child tags of the component
        words() {
            return this.$slots.default();
        },
        // Class for changing the width of table columns
        colWidthClass() {
            return this.colDiffWidth ? false : 'w-' + Math.floor(100 / this.cols);
        },
        // Divide the array of words into equal parts to build table rows
        wordRows() {
            let wordRows = [];
            for (let i = 0; i < this.words.length; i += this.cols) {
                wordRows.push(this.words.slice(i, i + this.cols));
            }
            return wordRows;
        }
    }
}
</script>
